const initState = {
    isLoading: false,
    data: [],
    error: null,
  };
  
  const BranchListReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_LOADING_BRANCH_LIST":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_BRANCH_LIST":
        return {
          ...state,
          isLoading: false,
          data: action.payload.data,
        };
      case "SET_ERROR_BRANCH_LIST":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default BranchListReducer;